import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, from, of } from 'rxjs';
import { AuthService } from './auth.service';
import { catchError, map } from 'rxjs/operators';
import { HandleAWSCognitoError } from './error.handler';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private authService: AuthService) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

        //console.log('in AuthGuard canActivate');

        return this.authService.getCurrentAuthenticatedUser()
                    .pipe(map( user => {
                        if (user) {
                            return true;
                        }
                        this.router.navigate(['/login']);
                        return false;

                    }), catchError( err => {
                            this.router.navigate(['/login']);
                            return of(false);
                    }));

    }

}
